var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"35vh"},attrs:{"id":"facility-error"}})
}
var staticRenderFns = []

export { render, staticRenderFns }